// Helpers for PDF endpoints called with { responseType: 'blob' }.

// Error bodies of blob requests arrive as a Blob; read the backend's JSON "message" out of it.
export const blobErrorMessage = async (error, fallback = 'Something went wrong. Please try again.') => {
  if (!error?.response) {
    return 'Could not reach the server. Check your connection and try again.';
  }
  const data = error.response.data;
  try {
    const text = typeof data?.text === 'function' ? await data.text() : JSON.stringify(data);
    const body = JSON.parse(text);
    return body?.message || body?.data?.message || fallback;
  } catch (e) {
    return fallback;
  }
};

export const readBlobJson = async (blob) => JSON.parse(await blob.text());

export const filenameFromResponse = (response, fallback) => {
  const header = response?.headers?.['content-disposition'] || '';
  const match = header.match(/filename="?([^"]+)"?/i);
  return match ? match[1] : fallback;
};

const saveWithLink = (url, filename) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

// Opens the PDF in a new tab (so it can be printed); if the browser blocks the pop-up, downloads it instead.
// Always saves when openInTab is false. The object URL is released once the browser has had time to load it.
export const deliverPdf = (blob, filename, { openInTab = true } = {}) => {
  const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const win = openInTab ? window.open(url, '_blank') : null;
  if (!win) {
    saveWithLink(url, filename);
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
